module.exports = __webpack_public_path__ + "static/media/MQA_Header_Logo.35fc8843.png";